module.exports = __webpack_public_path__ + "img/cuba.24bc73af.png";